'use client';

import { isServerSide } from '@/helpers';
// Since QueryClientProvider relies on useContext under the hood, we have to put 'use client' on top
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 1000 * 60 * 2, // 2 minutes
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

function getQueryClientOriginal() {
  if (isServerSide()) {
    // Server: always make a new query client
    return makeQueryClient();
  } else {
    // Browser: make a new query client if we don't already have one
    // This is very important so we don't re-make a new client if React
    // suspends during the initial render. This may not be needed if we
    // have a suspense boundary BELOW the creation of the query client
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}

export default function WrapperQueryClientProvider({ children }: { children: ReactNode }) {
  // NOTE: Avoid useState when initializing the query client if you don't
  //       have a suspense boundary between this and the code that may
  //       suspend because React will throw away the client on the initial
  //       render if it suspends and there is no boundary
  const queryClient = getQueryClientOriginal();

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

// 'use client';

// import { isServerSide } from '@/helpers';
// // Since QueryClientProvider relies on useContext under the hood, we have to put 'use client' on top
// import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactNode, useState } from 'react';

// export default function QueryClientProviderComponent({ children }: { children: ReactNode }) {
//   // NOTE: Avoid useState when initializing the query client if you don't
//   //       have a suspense boundary between this and the code that may
//   //       suspend because React will throw away the client on the initial
//   //       render if it suspends and there is no boundary
//   const [queryClient] = useState(
//     new QueryClient({
//       defaultOptions: {
//         queries: {
//           // With SSR, we usually want to set some default staleTime
//           // above 0 to avoid refetching immediately on the client
//           staleTime: 3 * 1000,
//         },
//       },
//     }),
//   );

//   return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
// }
